import { SelectItem, DetailItems } from '@/model/types'

export const Canton: SelectItem[] = [
    { key: 'AG', value: 'Aargau' },
    { key: 'AI', value: 'Appenzell Innerrhoden' },
    { key: 'AR', value: 'Appenzell Ausserrhoden' },
    { key: 'BE', value: 'Bern' },
    { key: 'BL', value: 'Basel-Landschaft' },
    { key: 'BS', value: 'Basel-Stadt' },
    { key: 'FL', value: 'Lichtenstein' },
    { key: 'FR', value: 'Freiburg' },
    { key: 'GE', value: 'Genf' },
    { key: 'GL', value: 'Glarus' },
    { key: 'GR', value: 'Graubünden' },
    { key: 'JU', value: 'Jura' },
    { key: 'LU', value: 'Luzern' },
    { key: 'NE', value: 'Neuenburg' },
    { key: 'NW', value: 'Nidwalden' },
    { key: 'OW', value: 'Obwalden' },
    { key: 'SG', value: 'St. Gallen' },
    { key: 'SH', value: 'Schaffhausen' },
    { key: 'SO', value: 'Solothurn' },
    { key: 'SZ', value: 'Schwyz' },
    { key: 'TG', value: 'Thurgau' },
    { key: 'TI', value: 'Tessin' },
    { key: 'UR', value: 'Uri' },
    { key: 'VD', value: 'Waadt' },
    { key: 'VS', value: 'Wallis' },
    { key: 'ZG', value: 'Zug' },
    { key: 'ZH', value: 'Zürich' },
]

export const Details: DetailItems = {
    Hochschule: [
        { key: 'Hochschule_CAS', value: 'CAS' },
        { key: 'Hochschule_DAS', value: 'DAS' },
        { key: 'Hochschule_MAS', value: 'MAS' },
        {
            key: 'Hochschule_Fachhochschulen_Paedagogische_Hochschulen_Vollzeit',
            value: 'Fachhochschulen / pädagogische Hochschulen – Vollzeit',
        },
        { key: 'Hochschule_Hoehere_Fachschulen_Teilzeit', value: 'Höhere Fachschulen – Teilzeit' },
        { key: 'Hochschule_Hoehere_Fachschulen_Vollzeit', value: 'Höhere Fachschulen – Vollzeit' },
        { key: 'Hochschule_Musikhochschule_Vollzeit', value: 'Musikhochschule – Vollzeit' },
        {
            key: 'Hochschule_Universitaere_Hochschule_Vollzeit',
            value: 'Universitäre Hochschule – Vollzeit',
        },
    ],
    Gymnasium: [
        { key: 'Gymnasium_Sekundarstufe_II_Vollzeit', value: 'Sekundarstufe II – Vollzeit' },
    ],
    Berufsschule: [
        {
            key: 'Berufsschule_Hoehere_Fachschulen_Teilzeit',
            value: 'Höhere Fachschulen – Teilzeit',
        },
        {
            key: 'Berufsschule_Hoehere_Fachschulen_Vollzeit',
            value: 'Höhere Fachschulen – Vollzeit',
        },
        { key: 'Berufsschule_Sekundarstufe_II_Teilzeit', value: 'Sekundarstufe II – Teilzeit' },
        { key: 'Berufsschule_Sekundarstufe_II_Vollzeit', value: 'Sekundarstufe II – Vollzeit' },
    ],
    Volksschule: [
        { key: 'Volksschule_Obligatorische_Schule', value: 'Obligatorische Schule' },
    ],
    // New category for Zentralschweizer Verträge
    Zentralschweizer: [
        {
            key: 'Zentralschweizer_Vertraege_Universal',
            value: 'Zentralschweizer Verträge (Universal)',
        },
        { key: 'ZS_VS', value: 'Zentralschweizer Vertrag (Volksschule)' },
        { key: 'ZS_S2P', value: 'Zentralschweizer Vertrag (Sek II/Tertiär)' },
    ],
}

export const SchoolType: SelectItem[] = [
    { key: 'Hochschule', value: 'Hochschule' },
    { key: 'Gymnasium', value: 'Gymnasium' },
    { key: 'Berufsschule', value: 'Berufsschule' },
    { key: 'Volksschule', value: 'Volksschule' },
]
